import { InstantiateExpr } from '@angular/compiler';
import { Component, effect, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiSelectComponent } from '@engie-group/fluid-design-system-angular';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { EFABlockDto, FirstHydroInstructionDto, MinimumBidPricesDto, QuickReservePricingTargetDto, QuickReserveStandingLimitsDto, SpreadsDto } from 'src/app/core/Dtos/fhc-hydro/instructions-dto';
import { FirstHydroInstructionsGridDto } from 'src/app/core/Dtos/fhc-hydro/instructions-grid-dto';
import { ListItemData } from 'src/app/core/Dtos/list-item-data';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { FhcHydroService } from 'src/app/core/services/fhc-hydro.service';
import { GeneralDataService } from 'src/app/core/services/general-data.service';

@Component({
  selector: 'app-fhc',
  templateUrl: './fhc.component.html',
  styleUrl: './fhc.component.scss',
  standalone: false
})
export class FhcComponent {
  public Instruction: FirstHydroInstructionDto = new FirstHydroInstructionDto();
  // public BMUList: string[] = [];
   

  @ViewChild(MultiSelectComponent)
  _selectedSettlements: MultiSelectComponent | undefined;

  constructor(
    private _generalDataService: GeneralDataService,
    private _fhcHydroService: FhcHydroService,
    private _router: Router,
    private _alertService: AlertsService,
    private _activatedRoute: ActivatedRoute,
    private _dateFormatHelper: DateFormatHelperService
  ) {
    this.Instruction.units = "ALL";

    let id = _activatedRoute.snapshot.paramMap.get("id");
    if (id !== null)
      this.GetInstruction(parseInt(id));
  }

  GetInstruction(id: number) {
    this._fhcHydroService.GetInstructionById(id).subscribe(
      resp => {
        resp.issuedFrom = resp.issuedFrom.toString().split('T')[0];
        resp.issuedTo = resp.issuedTo.toString().split('T')[0];
        this.Instruction = resp;
      }
    )
  }

  public SaveInstruction() {
    console.log(this.Instruction); 
    this._fhcHydroService.SaveInstruction(this.Instruction).subscribe(
      resp => this.Cancel()
    );
  }

  public Cancel() {
    this._router.navigate(['fhc']);
  }

  DeleteInstance(instance: Array<any>, i: number){
    instance.splice(i, 1);
  }

  AddSpread(instance: Array<SpreadsDto>){
    instance.push(new SpreadsDto());
  }
  AddEFABlockDTO(instance: Array<EFABlockDto>)
  {
    instance.push(new EFABlockDto());
  }
  AddStandingLimit(){
    this.Instruction.instructionData.quickReserveStandingLimits.push(new QuickReserveStandingLimitsDto())
  }
  AddPricingTarget(){
    this.Instruction.instructionData.quickReservePricingTarget.push(new QuickReservePricingTargetDto())
  }
  AddMinimumBidPrice(){
    this.Instruction.instructionData.minimumBidPrices.push(new MinimumBidPricesDto)
  }

  onStartDateChanged(event: any) {
    try {
      this.Instruction.issuedTo = new Date(this.Instruction.issuedFrom);
      this.Instruction.issuedTo.setDate(this.Instruction.issuedTo.getDate()+ 7);
      this.Instruction.issuedTo = this.Instruction.issuedTo.toISOString().split('T')[0]
    }
    catch {
      this.Instruction.issuedTo = new Date().toISOString().split('T')[0];
    }
  }
}
